import Immutable from 'immutable';
import {
  FLAG_GETTING_MAINTENANCE_SERVICE_ORDERS,
  GET_MAINTENANCE_SERVICE_ORDERS,
  CLEAR_MAINTENANCE_SERVICE_ORDERS,
  FLAG_MAINTENANCE_SERVICE_ORDER_ACTIVITY,
  CLEAR_MAINTENANCE_SERVICE_ORDER,
  GET_MAINTENANCE_SERVICE_ORDER,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_SERVICE_ORDERS:
      return state.setIn(['all', 'loading'], payload);
    case GET_MAINTENANCE_SERVICE_ORDERS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_SERVICE_ORDERS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_MAINTENANCE_SERVICE_ORDER_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_MAINTENANCE_SERVICE_ORDER:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_SERVICE_ORDER:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
